/**
 * Generated by orval v8.12.2 🍺
 * Do not edit manually.
 * PEXIFY API
 * PEXIFY API contract (FE ↔ BE).
 *
 * **Status:** M0 initial draft (2026-05-21). This contract is FE-shaped during M0/M1/M2 operational
 * simulation phase per `pol-build-sequence`. Backend implementation begins at M3.
 *
 * **Scope (M0):** IQ-1 Pending Updates Queue endpoints + auth placeholder. Other endpoints added
 * as M0/M1/M2 prototype reveals needs.
 *
 * **Permanent architectural invariant:** JSON only (no GraphQL, no SOAP, no XML). See
 * `planning/nodes/policies/decoupled-api.md` for the full invariant + 5 strategic reasons.
 *
 * OpenAPI spec version: 0.1.0-m0-draft
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ListAdminMessagingConversationsParams,
  ListAdminMessagingMessagesParams,
  ListMessagingConversationsParams,
  ListMessagingMessagesParams,
  MessagingAdminAssignmentRequest,
  MessagingAdminConversation,
  MessagingAdminConversationPage,
  MessagingAdminOperationsRequest,
  MessagingAssignmentConflictProblem,
  MessagingCapabilities,
  MessagingConversation,
  MessagingConversationCreate,
  MessagingConversationPage,
  MessagingConversationUpdate,
  MessagingMessage,
  MessagingMessageCreate,
  MessagingMessagePage,
  MessagingReadReceipt,
  MessagingReadRequest,
  MessagingUnreadSummary,
  Problem
} from '../model';

import { orvalClient } from '../../orval-client';




export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;


export type getMessagingCapabilitiesResponse200 = {
  data: MessagingCapabilities
  status: 200
}

export type getMessagingCapabilitiesResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200>
}

export type getMessagingCapabilitiesResponseSuccess = (getMessagingCapabilitiesResponse200) & {
  headers: Headers;
};
export type getMessagingCapabilitiesResponseError = (getMessagingCapabilitiesResponseDefault) & {
  headers: Headers;
};

export type getMessagingCapabilitiesResponse = (getMessagingCapabilitiesResponseSuccess | getMessagingCapabilitiesResponseError)

export const getGetMessagingCapabilitiesUrl = () => {




  return `/api/v1/messaging/capabilities`
}

/**
 * Returns the effective Messaging rollout for the authenticated actor and
 * surface. Any missing endpoint, 404, invalid payload, unknown level, or
 * request failure maps to level=off in the frontend. Admin operation flags
 * are server-derived from exact Messaging capabilities; A1/A2 identity,
 * role labels, assignment, and routing team never imply authority. Personal
 * mark-read relies on can_view_inbox because its route requires exactly
 * messaging.conversation.view and advances only the authenticated user.
 *
 * @summary Get fail-closed Messaging rollout capabilities
 */
export const getMessagingCapabilities = async ( options?: RequestInit): Promise<getMessagingCapabilitiesResponse> => {

  return orvalClient<getMessagingCapabilitiesResponse>(getGetMessagingCapabilitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMessagingCapabilitiesQueryKey = () => {
    return [
    `/api/v1/messaging/capabilities`
    ] as const;
    }


export const getGetMessagingCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof getMessagingCapabilities>>, TError = Problem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingCapabilities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagingCapabilitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessagingCapabilities>>> = ({ signal }) => getMessagingCapabilities({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessagingCapabilities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessagingCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getMessagingCapabilities>>>
export type GetMessagingCapabilitiesQueryError = Problem


export function useGetMessagingCapabilities<TData = Awaited<ReturnType<typeof getMessagingCapabilities>>, TError = Problem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingCapabilities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagingCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getMessagingCapabilities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagingCapabilities<TData = Awaited<ReturnType<typeof getMessagingCapabilities>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingCapabilities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagingCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getMessagingCapabilities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagingCapabilities<TData = Awaited<ReturnType<typeof getMessagingCapabilities>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingCapabilities>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fail-closed Messaging rollout capabilities
 */

export function useGetMessagingCapabilities<TData = Awaited<ReturnType<typeof getMessagingCapabilities>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingCapabilities>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessagingCapabilitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getMessagingUnreadSummaryResponse200 = {
  data: MessagingUnreadSummary
  status: 200
}

export type getMessagingUnreadSummaryResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200>
}

export type getMessagingUnreadSummaryResponseSuccess = (getMessagingUnreadSummaryResponse200) & {
  headers: Headers;
};
export type getMessagingUnreadSummaryResponseError = (getMessagingUnreadSummaryResponseDefault) & {
  headers: Headers;
};

export type getMessagingUnreadSummaryResponse = (getMessagingUnreadSummaryResponseSuccess | getMessagingUnreadSummaryResponseError)

export const getGetMessagingUnreadSummaryUrl = () => {




  return `/api/v1/messaging/unread-summary`
}

/**
 * @summary Get the current app membership's Messaging unread total
 */
export const getMessagingUnreadSummary = async ( options?: RequestInit): Promise<getMessagingUnreadSummaryResponse> => {

  return orvalClient<getMessagingUnreadSummaryResponse>(getGetMessagingUnreadSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMessagingUnreadSummaryQueryKey = () => {
    return [
    `/api/v1/messaging/unread-summary`
    ] as const;
    }


export const getGetMessagingUnreadSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError = Problem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagingUnreadSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessagingUnreadSummary>>> = ({ signal }) => getMessagingUnreadSummary({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessagingUnreadSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMessagingUnreadSummary>>>
export type GetMessagingUnreadSummaryQueryError = Problem


export function useGetMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError = Problem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagingUnreadSummary>>,
          TError,
          Awaited<ReturnType<typeof getMessagingUnreadSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagingUnreadSummary>>,
          TError,
          Awaited<ReturnType<typeof getMessagingUnreadSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the current app membership's Messaging unread total
 */

export function useGetMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessagingUnreadSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getOrCreateMessagingSupportConversationResponse200 = {
  data: MessagingConversation
  status: 200
}

export type getOrCreateMessagingSupportConversationResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200>
}

export type getOrCreateMessagingSupportConversationResponseSuccess = (getOrCreateMessagingSupportConversationResponse200) & {
  headers: Headers;
};
export type getOrCreateMessagingSupportConversationResponseError = (getOrCreateMessagingSupportConversationResponseDefault) & {
  headers: Headers;
};

export type getOrCreateMessagingSupportConversationResponse = (getOrCreateMessagingSupportConversationResponseSuccess | getOrCreateMessagingSupportConversationResponseError)

export const getGetOrCreateMessagingSupportConversationUrl = () => {




  return `/api/v1/messaging/support-conversation`
}

/**
 * Returns the single evergreen PEXIFY Support conversation for the
 * authenticated APP organization and seller/supply side, creating it when
 * absent. Organization and side are derived by the server from the active
 * authenticated membership and cannot be selected by the client. Retrying
 * this bodyless command returns the same conversation.
 *
 * @summary Get or create the current organization's PEXIFY Support conversation
 */
export const getOrCreateMessagingSupportConversation = async ( options?: RequestInit): Promise<getOrCreateMessagingSupportConversationResponse> => {

  return orvalClient<getOrCreateMessagingSupportConversationResponse>(getGetOrCreateMessagingSupportConversationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGetOrCreateMessagingSupportConversationMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getOrCreateMessagingSupportConversation>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getOrCreateMessagingSupportConversation>>, TError,void, TContext> => {

const mutationKey = ['getOrCreateMessagingSupportConversation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getOrCreateMessagingSupportConversation>>, void> = () => {


          return  getOrCreateMessagingSupportConversation()
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetOrCreateMessagingSupportConversationMutationResult = NonNullable<Awaited<ReturnType<typeof getOrCreateMessagingSupportConversation>>>

    export type GetOrCreateMessagingSupportConversationMutationError = Problem

    /**
 * @summary Get or create the current organization's PEXIFY Support conversation
 */
export const useGetOrCreateMessagingSupportConversation = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getOrCreateMessagingSupportConversation>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getOrCreateMessagingSupportConversation>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetOrCreateMessagingSupportConversationMutationOptions(options), queryClient);
    }
    export type listMessagingConversationsResponse200 = {
  data: MessagingConversationPage
  status: 200
}

export type listMessagingConversationsResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200>
}

export type listMessagingConversationsResponseSuccess = (listMessagingConversationsResponse200) & {
  headers: Headers;
};
export type listMessagingConversationsResponseError = (listMessagingConversationsResponseDefault) & {
  headers: Headers;
};

export type listMessagingConversationsResponse = (listMessagingConversationsResponseSuccess | listMessagingConversationsResponseError)

export const getListMessagingConversationsUrl = (params?: ListMessagingConversationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/messaging/conversations?${stringifiedParams}` : `/api/v1/messaging/conversations`
}

/**
 * Visibility is derived from the authenticated actor, active organization,
 * membership, and seller/supply surface. The client cannot override an
 * organization, audience, counterpart, or side. Results expose only the
 * entity projection safe for that surface.
 *
 * @summary List conversations visible to the current app actor
 */
export const listMessagingConversations = async (params?: ListMessagingConversationsParams, options?: RequestInit): Promise<listMessagingConversationsResponse> => {

  return orvalClient<listMessagingConversationsResponse>(getListMessagingConversationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMessagingConversationsQueryKey = (params?: ListMessagingConversationsParams,) => {
    return [
    `/api/v1/messaging/conversations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMessagingConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listMessagingConversations>>, TError = Problem>(params?: ListMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingConversations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMessagingConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMessagingConversations>>> = ({ signal }) => listMessagingConversations(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMessagingConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMessagingConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listMessagingConversations>>>
export type ListMessagingConversationsQueryError = Problem


export function useListMessagingConversations<TData = Awaited<ReturnType<typeof listMessagingConversations>>, TError = Problem>(
 params: undefined |  ListMessagingConversationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingConversations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMessagingConversations>>,
          TError,
          Awaited<ReturnType<typeof listMessagingConversations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMessagingConversations<TData = Awaited<ReturnType<typeof listMessagingConversations>>, TError = Problem>(
 params?: ListMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingConversations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMessagingConversations>>,
          TError,
          Awaited<ReturnType<typeof listMessagingConversations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMessagingConversations<TData = Awaited<ReturnType<typeof listMessagingConversations>>, TError = Problem>(
 params?: ListMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List conversations visible to the current app actor
 */

export function useListMessagingConversations<TData = Awaited<ReturnType<typeof listMessagingConversations>>, TError = Problem>(
 params?: ListMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMessagingConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type createMessagingConversationResponse201 = {
  data: MessagingConversation
  status: 201
}

export type createMessagingConversationResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 201>
}

export type createMessagingConversationResponseSuccess = (createMessagingConversationResponse201) & {
  headers: Headers;
};
export type createMessagingConversationResponseError = (createMessagingConversationResponseDefault) & {
  headers: Headers;
};

export type createMessagingConversationResponse = (createMessagingConversationResponseSuccess | createMessagingConversationResponseError)

export const getCreateMessagingConversationUrl = () => {




  return `/api/v1/messaging/conversations`
}

/**
 * Starts a conversation only when the authenticated actor can already see
 * the linked entity. The server derives and validates the organization,
 * side, counterpart, and audience; the request cannot nominate them.
 *
 * @summary Start a conversation in the current actor's app scope
 */
export const createMessagingConversation = async (messagingConversationCreate: MessagingConversationCreate, options?: RequestInit): Promise<createMessagingConversationResponse> => {

  return orvalClient<createMessagingConversationResponse>(getCreateMessagingConversationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingConversationCreate)
  }
);}




export const getCreateMessagingConversationMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMessagingConversation>>, TError,{data: MessagingConversationCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMessagingConversation>>, TError,{data: MessagingConversationCreate}, TContext> => {

const mutationKey = ['createMessagingConversation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMessagingConversation>>, {data: MessagingConversationCreate}> = (props) => {
          const {data} = props ?? {};

          return  createMessagingConversation(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMessagingConversationMutationResult = NonNullable<Awaited<ReturnType<typeof createMessagingConversation>>>
    export type CreateMessagingConversationMutationBody = MessagingConversationCreate
    export type CreateMessagingConversationMutationError = Problem

    /**
 * @summary Start a conversation in the current actor's app scope
 */
export const useCreateMessagingConversation = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMessagingConversation>>, TError,{data: MessagingConversationCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMessagingConversation>>,
        TError,
        {data: MessagingConversationCreate},
        TContext
      > => {
      return useMutation(getCreateMessagingConversationMutationOptions(options), queryClient);
    }
    export type getMessagingConversationResponse200 = {
  data: MessagingConversation
  status: 200
}

export type getMessagingConversationResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200>
}

export type getMessagingConversationResponseSuccess = (getMessagingConversationResponse200) & {
  headers: Headers;
};
export type getMessagingConversationResponseError = (getMessagingConversationResponseDefault) & {
  headers: Headers;
};

export type getMessagingConversationResponse = (getMessagingConversationResponseSuccess | getMessagingConversationResponseError)

export const getGetMessagingConversationUrl = (conversationId: string,) => {




  return `/api/v1/messaging/conversations/${conversationId}`
}

/**
 * Returns the surface-safe conversation projection only after membership,
 * organization, side, and linked-entity ownership checks.
 *
 * @summary Get one own-scope conversation
 */
export const getMessagingConversation = async (conversationId: string, options?: RequestInit): Promise<getMessagingConversationResponse> => {

  return orvalClient<getMessagingConversationResponse>(getGetMessagingConversationUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMessagingConversationQueryKey = (conversationId: string,) => {
    return [
    `/api/v1/messaging/conversations/${conversationId}`
    ] as const;
    }


export const getGetMessagingConversationQueryOptions = <TData = Awaited<ReturnType<typeof getMessagingConversation>>, TError = Problem>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingConversation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagingConversationQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessagingConversation>>> = ({ signal }) => getMessagingConversation(conversationId, { signal });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessagingConversation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessagingConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getMessagingConversation>>>
export type GetMessagingConversationQueryError = Problem


export function useGetMessagingConversation<TData = Awaited<ReturnType<typeof getMessagingConversation>>, TError = Problem>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingConversation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagingConversation>>,
          TError,
          Awaited<ReturnType<typeof getMessagingConversation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagingConversation<TData = Awaited<ReturnType<typeof getMessagingConversation>>, TError = Problem>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingConversation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagingConversation>>,
          TError,
          Awaited<ReturnType<typeof getMessagingConversation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagingConversation<TData = Awaited<ReturnType<typeof getMessagingConversation>>, TError = Problem>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingConversation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one own-scope conversation
 */

export function useGetMessagingConversation<TData = Awaited<ReturnType<typeof getMessagingConversation>>, TError = Problem>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingConversation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessagingConversationQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type updateMessagingConversationResponse200 = {
  data: MessagingConversation
  status: 200
}

export type updateMessagingConversationResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200>
}

export type updateMessagingConversationResponseSuccess = (updateMessagingConversationResponse200) & {
  headers: Headers;
};
export type updateMessagingConversationResponseError = (updateMessagingConversationResponseDefault) & {
  headers: Headers;
};

export type updateMessagingConversationResponse = (updateMessagingConversationResponseSuccess | updateMessagingConversationResponseError)

export const getUpdateMessagingConversationUrl = (conversationId: string,) => {




  return `/api/v1/messaging/conversations/${conversationId}`
}

/**
 * Updates only allowed status state for a conversation that remains in the
 * authenticated actor's derived scope.
 *
 * @summary Update one own-scope conversation status
 */
export const updateMessagingConversation = async (conversationId: string,
    messagingConversationUpdate: MessagingConversationUpdate, options?: RequestInit): Promise<updateMessagingConversationResponse> => {

  return orvalClient<updateMessagingConversationResponse>(getUpdateMessagingConversationUrl(conversationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingConversationUpdate)
  }
);}




export const getUpdateMessagingConversationMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMessagingConversation>>, TError,{conversationId: string;data: MessagingConversationUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateMessagingConversation>>, TError,{conversationId: string;data: MessagingConversationUpdate}, TContext> => {

const mutationKey = ['updateMessagingConversation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMessagingConversation>>, {conversationId: string;data: MessagingConversationUpdate}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  updateMessagingConversation(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMessagingConversationMutationResult = NonNullable<Awaited<ReturnType<typeof updateMessagingConversation>>>
    export type UpdateMessagingConversationMutationBody = MessagingConversationUpdate
    export type UpdateMessagingConversationMutationError = Problem

    /**
 * @summary Update one own-scope conversation status
 */
export const useUpdateMessagingConversation = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMessagingConversation>>, TError,{conversationId: string;data: MessagingConversationUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMessagingConversation>>,
        TError,
        {conversationId: string;data: MessagingConversationUpdate},
        TContext
      > => {
      return useMutation(getUpdateMessagingConversationMutationOptions(options), queryClient);
    }
    export type listMessagingMessagesResponse200 = {
  data: MessagingMessagePage
  status: 200
}

export type listMessagingMessagesResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200>
}

export type listMessagingMessagesResponseSuccess = (listMessagingMessagesResponse200) & {
  headers: Headers;
};
export type listMessagingMessagesResponseError = (listMessagingMessagesResponseDefault) & {
  headers: Headers;
};

export type listMessagingMessagesResponse = (listMessagingMessagesResponseSuccess | listMessagingMessagesResponseError)

export const getListMessagingMessagesUrl = (conversationId: string,
    params?: ListMessagingMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/messaging/conversations/${conversationId}/messages?${stringifiedParams}` : `/api/v1/messaging/conversations/${conversationId}/messages`
}

/**
 * Returns cursor-paginated history only after the same membership,
 * organization, side, and linked-entity checks as the conversation.
 *
 * @summary List message history for one own-scope conversation
 */
export const listMessagingMessages = async (conversationId: string,
    params?: ListMessagingMessagesParams, options?: RequestInit): Promise<listMessagingMessagesResponse> => {

  return orvalClient<listMessagingMessagesResponse>(getListMessagingMessagesUrl(conversationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMessagingMessagesQueryKey = (conversationId: string,
    params?: ListMessagingMessagesParams,) => {
    return [
    `/api/v1/messaging/conversations/${conversationId}/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMessagingMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listMessagingMessages>>, TError = Problem>(conversationId: string,
    params?: ListMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingMessages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMessagingMessagesQueryKey(conversationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMessagingMessages>>> = ({ signal }) => listMessagingMessages(conversationId,params, { signal });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMessagingMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMessagingMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listMessagingMessages>>>
export type ListMessagingMessagesQueryError = Problem


export function useListMessagingMessages<TData = Awaited<ReturnType<typeof listMessagingMessages>>, TError = Problem>(
 conversationId: string,
    params: undefined |  ListMessagingMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMessagingMessages>>,
          TError,
          Awaited<ReturnType<typeof listMessagingMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMessagingMessages<TData = Awaited<ReturnType<typeof listMessagingMessages>>, TError = Problem>(
 conversationId: string,
    params?: ListMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMessagingMessages>>,
          TError,
          Awaited<ReturnType<typeof listMessagingMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMessagingMessages<TData = Awaited<ReturnType<typeof listMessagingMessages>>, TError = Problem>(
 conversationId: string,
    params?: ListMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingMessages>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List message history for one own-scope conversation
 */

export function useListMessagingMessages<TData = Awaited<ReturnType<typeof listMessagingMessages>>, TError = Problem>(
 conversationId: string,
    params?: ListMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingMessages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMessagingMessagesQueryOptions(conversationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type createMessagingMessageResponse201 = {
  data: MessagingMessage
  status: 201
}

export type createMessagingMessageResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 201>
}

export type createMessagingMessageResponseSuccess = (createMessagingMessageResponse201) & {
  headers: Headers;
};
export type createMessagingMessageResponseError = (createMessagingMessageResponseDefault) & {
  headers: Headers;
};

export type createMessagingMessageResponse = (createMessagingMessageResponseSuccess | createMessagingMessageResponseError)

export const getCreateMessagingMessageUrl = (conversationId: string,) => {




  return `/api/v1/messaging/conversations/${conversationId}/messages`
}

/**
 * The server derives the author and audience. client_message_id provides
 * retry-safe idempotency. attachment_ids must reference PEXIFY Drive files
 * the actor may access. Internal notes require an explicit capability.
 *
 * @summary Send an idempotent message in one own-scope conversation
 */
export const createMessagingMessage = async (conversationId: string,
    messagingMessageCreate: MessagingMessageCreate, options?: RequestInit): Promise<createMessagingMessageResponse> => {

  return orvalClient<createMessagingMessageResponse>(getCreateMessagingMessageUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingMessageCreate)
  }
);}




export const getCreateMessagingMessageMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMessagingMessage>>, TError,{conversationId: string;data: MessagingMessageCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMessagingMessage>>, TError,{conversationId: string;data: MessagingMessageCreate}, TContext> => {

const mutationKey = ['createMessagingMessage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMessagingMessage>>, {conversationId: string;data: MessagingMessageCreate}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  createMessagingMessage(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMessagingMessageMutationResult = NonNullable<Awaited<ReturnType<typeof createMessagingMessage>>>
    export type CreateMessagingMessageMutationBody = MessagingMessageCreate
    export type CreateMessagingMessageMutationError = Problem

    /**
 * @summary Send an idempotent message in one own-scope conversation
 */
export const useCreateMessagingMessage = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMessagingMessage>>, TError,{conversationId: string;data: MessagingMessageCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMessagingMessage>>,
        TError,
        {conversationId: string;data: MessagingMessageCreate},
        TContext
      > => {
      return useMutation(getCreateMessagingMessageMutationOptions(options), queryClient);
    }
    export type markMessagingConversationReadResponse200 = {
  data: MessagingReadReceipt
  status: 200
}

export type markMessagingConversationReadResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200>
}

export type markMessagingConversationReadResponseSuccess = (markMessagingConversationReadResponse200) & {
  headers: Headers;
};
export type markMessagingConversationReadResponseError = (markMessagingConversationReadResponseDefault) & {
  headers: Headers;
};

export type markMessagingConversationReadResponse = (markMessagingConversationReadResponseSuccess | markMessagingConversationReadResponseError)

export const getMarkMessagingConversationReadUrl = (conversationId: string,) => {




  return `/api/v1/messaging/conversations/${conversationId}/read`
}

/**
 * Advances only the authenticated actor's own read position after
 * conversation visibility is revalidated.
 *
 * @summary Advance the actor's read position
 */
export const markMessagingConversationRead = async (conversationId: string,
    messagingReadRequest: MessagingReadRequest, options?: RequestInit): Promise<markMessagingConversationReadResponse> => {

  return orvalClient<markMessagingConversationReadResponse>(getMarkMessagingConversationReadUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingReadRequest)
  }
);}




export const getMarkMessagingConversationReadMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markMessagingConversationRead>>, TError,{conversationId: string;data: MessagingReadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markMessagingConversationRead>>, TError,{conversationId: string;data: MessagingReadRequest}, TContext> => {

const mutationKey = ['markMessagingConversationRead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markMessagingConversationRead>>, {conversationId: string;data: MessagingReadRequest}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  markMessagingConversationRead(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkMessagingConversationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markMessagingConversationRead>>>
    export type MarkMessagingConversationReadMutationBody = MessagingReadRequest
    export type MarkMessagingConversationReadMutationError = Problem

    /**
 * @summary Advance the actor's read position
 */
export const useMarkMessagingConversationRead = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markMessagingConversationRead>>, TError,{conversationId: string;data: MessagingReadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markMessagingConversationRead>>,
        TError,
        {conversationId: string;data: MessagingReadRequest},
        TContext
      > => {
      return useMutation(getMarkMessagingConversationReadMutationOptions(options), queryClient);
    }
    export type getAdminMessagingUnreadSummaryResponse200 = {
  data: MessagingUnreadSummary
  status: 200
}

export type getAdminMessagingUnreadSummaryResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200>
}

export type getAdminMessagingUnreadSummaryResponseSuccess = (getAdminMessagingUnreadSummaryResponse200) & {
  headers: Headers;
};
export type getAdminMessagingUnreadSummaryResponseError = (getAdminMessagingUnreadSummaryResponseDefault) & {
  headers: Headers;
};

export type getAdminMessagingUnreadSummaryResponse = (getAdminMessagingUnreadSummaryResponseSuccess | getAdminMessagingUnreadSummaryResponseError)

export const getGetAdminMessagingUnreadSummaryUrl = () => {




  return `/api/v1/admin/messaging/unread-summary`
}

/**
 * @summary Get the current admin membership's governed Messaging unread total
 */
export const getAdminMessagingUnreadSummary = async ( options?: RequestInit): Promise<getAdminMessagingUnreadSummaryResponse> => {

  return orvalClient<getAdminMessagingUnreadSummaryResponse>(getGetAdminMessagingUnreadSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminMessagingUnreadSummaryQueryKey = () => {
    return [
    `/api/v1/admin/messaging/unread-summary`
    ] as const;
    }


export const getGetAdminMessagingUnreadSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError = Problem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMessagingUnreadSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>> = ({ signal }) => getAdminMessagingUnreadSummary({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMessagingUnreadSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>>
export type GetAdminMessagingUnreadSummaryQueryError = Problem


export function useGetAdminMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError = Problem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>,
          TError,
          Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>,
          TError,
          Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the current admin membership's governed Messaging unread total
 */

export function useGetAdminMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError = Problem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMessagingUnreadSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type listAdminMessagingConversationsResponse200 = {
  data: MessagingAdminConversationPage
  status: 200
}

export type listAdminMessagingConversationsResponse403 = {
  data: void
  status: 403
}

export type listAdminMessagingConversationsResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403>
}

export type listAdminMessagingConversationsResponseSuccess = (listAdminMessagingConversationsResponse200) & {
  headers: Headers;
};
export type listAdminMessagingConversationsResponseError = (listAdminMessagingConversationsResponse403 | listAdminMessagingConversationsResponseDefault) & {
  headers: Headers;
};

export type listAdminMessagingConversationsResponse = (listAdminMessagingConversationsResponseSuccess | listAdminMessagingConversationsResponseError)

export const getListAdminMessagingConversationsUrl = (params?: ListAdminMessagingConversationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/messaging/conversations?${stringifiedParams}` : `/api/v1/admin/messaging/conversations`
}

/**
 * This governance-declared route requires containment within the declared
 * support or governance scope, explicit messaging.conversation.view
 * capability, and an audit record. Ring-3 alone is insufficient. Access to
 * private team chat or break-glass inspection is not authorized here.
 *
 * @summary List conversations through governed admin access
 */
export const listAdminMessagingConversations = async (params?: ListAdminMessagingConversationsParams, options?: RequestInit): Promise<listAdminMessagingConversationsResponse> => {

  return orvalClient<listAdminMessagingConversationsResponse>(getListAdminMessagingConversationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminMessagingConversationsQueryKey = (params?: ListAdminMessagingConversationsParams,) => {
    return [
    `/api/v1/admin/messaging/conversations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminMessagingConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError = void | Problem>(params?: ListAdminMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminMessagingConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminMessagingConversations>>> = ({ signal }) => listAdminMessagingConversations(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminMessagingConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminMessagingConversations>>>
export type ListAdminMessagingConversationsQueryError = void | Problem


export function useListAdminMessagingConversations<TData = Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError = void | Problem>(
 params: undefined |  ListAdminMessagingConversationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminMessagingConversations>>,
          TError,
          Awaited<ReturnType<typeof listAdminMessagingConversations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminMessagingConversations<TData = Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError = void | Problem>(
 params?: ListAdminMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminMessagingConversations>>,
          TError,
          Awaited<ReturnType<typeof listAdminMessagingConversations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminMessagingConversations<TData = Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError = void | Problem>(
 params?: ListAdminMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List conversations through governed admin access
 */

export function useListAdminMessagingConversations<TData = Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError = void | Problem>(
 params?: ListAdminMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminMessagingConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getAdminMessagingConversationResponse200 = {
  data: MessagingAdminConversation
  status: 200
}

export type getAdminMessagingConversationResponse403 = {
  data: void
  status: 403
}

export type getAdminMessagingConversationResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403>
}

export type getAdminMessagingConversationResponseSuccess = (getAdminMessagingConversationResponse200) & {
  headers: Headers;
};
export type getAdminMessagingConversationResponseError = (getAdminMessagingConversationResponse403 | getAdminMessagingConversationResponseDefault) & {
  headers: Headers;
};

export type getAdminMessagingConversationResponse = (getAdminMessagingConversationResponseSuccess | getAdminMessagingConversationResponseError)

export const getGetAdminMessagingConversationUrl = (conversationId: string,) => {




  return `/api/v1/admin/messaging/conversations/${conversationId}`
}

/**
 * This governance-declared route requires containment within the declared
 * support or governance scope, explicit messaging.conversation.view
 * capability, and an audit record. Ring-3 alone is insufficient. This
 * endpoint does not authorize private team chat or break-glass inspection.
 *
 * @summary Get one conversation through governed admin access
 */
export const getAdminMessagingConversation = async (conversationId: string, options?: RequestInit): Promise<getAdminMessagingConversationResponse> => {

  return orvalClient<getAdminMessagingConversationResponse>(getGetAdminMessagingConversationUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminMessagingConversationQueryKey = (conversationId: string,) => {
    return [
    `/api/v1/admin/messaging/conversations/${conversationId}`
    ] as const;
    }


export const getGetAdminMessagingConversationQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError = void | Problem>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMessagingConversationQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMessagingConversation>>> = ({ signal }) => getAdminMessagingConversation(conversationId, { signal });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMessagingConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMessagingConversation>>>
export type GetAdminMessagingConversationQueryError = void | Problem


export function useGetAdminMessagingConversation<TData = Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError = void | Problem>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMessagingConversation>>,
          TError,
          Awaited<ReturnType<typeof getAdminMessagingConversation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMessagingConversation<TData = Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError = void | Problem>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMessagingConversation>>,
          TError,
          Awaited<ReturnType<typeof getAdminMessagingConversation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMessagingConversation<TData = Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError = void | Problem>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one conversation through governed admin access
 */

export function useGetAdminMessagingConversation<TData = Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError = void | Problem>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMessagingConversationQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type claimAdminMessagingConversationResponse200 = {
  data: MessagingAdminConversation
  status: 200
}

export type claimAdminMessagingConversationResponse403 = {
  data: Problem
  status: 403
}

export type claimAdminMessagingConversationResponse404 = {
  data: Problem
  status: 404
}

export type claimAdminMessagingConversationResponse409 = {
  data: MessagingAssignmentConflictProblem
  status: 409
}

export type claimAdminMessagingConversationResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404 | 409>
}

export type claimAdminMessagingConversationResponseSuccess = (claimAdminMessagingConversationResponse200) & {
  headers: Headers;
};
export type claimAdminMessagingConversationResponseError = (claimAdminMessagingConversationResponse403 | claimAdminMessagingConversationResponse404 | claimAdminMessagingConversationResponse409 | claimAdminMessagingConversationResponseDefault) & {
  headers: Headers;
};

export type claimAdminMessagingConversationResponse = (claimAdminMessagingConversationResponseSuccess | claimAdminMessagingConversationResponseError)

export const getClaimAdminMessagingConversationUrl = (conversationId: string,) => {




  return `/api/v1/admin/messaging/conversations/${conversationId}/claim`
}

/**
 * Requires current conversation containment plus the exact capabilities
 * messaging.conversation.view and messaging.assignment.claim. Every
 * successful claim is audited. A1/A2 classification and Ring-3 scope never
 * imply either capability. This contract makes no backend atomicity,
 * realtime, provider, or transport claim.
 *
 * @summary Claim an unassigned conversation for the current PEXIFY user
 */
export const claimAdminMessagingConversation = async (conversationId: string, options?: RequestInit): Promise<claimAdminMessagingConversationResponse> => {

  return orvalClient<claimAdminMessagingConversationResponse>(getClaimAdminMessagingConversationUrl(conversationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getClaimAdminMessagingConversationMutationOptions = <TError = Problem | MessagingAssignmentConflictProblem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimAdminMessagingConversation>>, TError,{conversationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof claimAdminMessagingConversation>>, TError,{conversationId: string}, TContext> => {

const mutationKey = ['claimAdminMessagingConversation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimAdminMessagingConversation>>, {conversationId: string}> = (props) => {
          const {conversationId} = props ?? {};

          return  claimAdminMessagingConversation(conversationId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClaimAdminMessagingConversationMutationResult = NonNullable<Awaited<ReturnType<typeof claimAdminMessagingConversation>>>

    export type ClaimAdminMessagingConversationMutationError = Problem | MessagingAssignmentConflictProblem

    /**
 * @summary Claim an unassigned conversation for the current PEXIFY user
 */
export const useClaimAdminMessagingConversation = <TError = Problem | MessagingAssignmentConflictProblem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimAdminMessagingConversation>>, TError,{conversationId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof claimAdminMessagingConversation>>,
        TError,
        {conversationId: string},
        TContext
      > => {
      return useMutation(getClaimAdminMessagingConversationMutationOptions(options), queryClient);
    }
    export type updateAdminMessagingAssignmentResponse200 = {
  data: MessagingAdminConversation
  status: 200
}

export type updateAdminMessagingAssignmentResponse403 = {
  data: Problem
  status: 403
}

export type updateAdminMessagingAssignmentResponse404 = {
  data: Problem
  status: 404
}

export type updateAdminMessagingAssignmentResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type updateAdminMessagingAssignmentResponseSuccess = (updateAdminMessagingAssignmentResponse200) & {
  headers: Headers;
};
export type updateAdminMessagingAssignmentResponseError = (updateAdminMessagingAssignmentResponse403 | updateAdminMessagingAssignmentResponse404 | updateAdminMessagingAssignmentResponseDefault) & {
  headers: Headers;
};

export type updateAdminMessagingAssignmentResponse = (updateAdminMessagingAssignmentResponseSuccess | updateAdminMessagingAssignmentResponseError)

export const getUpdateAdminMessagingAssignmentUrl = (conversationId: string,) => {




  return `/api/v1/admin/messaging/conversations/${conversationId}/assignment`
}

/**
 * Requires current conversation containment plus the exact capabilities
 * messaging.conversation.view and messaging.assignment.reassign. Every
 * successful reassignment is audited. assignee_user_id does not select an
 * organization or grant authority. A1/A2 classification and Ring-3 scope
 * never imply either capability.
 *
 * @summary Reassign a conversation to another PEXIFY user
 */
export const updateAdminMessagingAssignment = async (conversationId: string,
    messagingAdminAssignmentRequest: MessagingAdminAssignmentRequest, options?: RequestInit): Promise<updateAdminMessagingAssignmentResponse> => {

  return orvalClient<updateAdminMessagingAssignmentResponse>(getUpdateAdminMessagingAssignmentUrl(conversationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingAdminAssignmentRequest)
  }
);}




export const getUpdateAdminMessagingAssignmentMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminMessagingAssignment>>, TError,{conversationId: string;data: MessagingAdminAssignmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminMessagingAssignment>>, TError,{conversationId: string;data: MessagingAdminAssignmentRequest}, TContext> => {

const mutationKey = ['updateAdminMessagingAssignment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminMessagingAssignment>>, {conversationId: string;data: MessagingAdminAssignmentRequest}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  updateAdminMessagingAssignment(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminMessagingAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminMessagingAssignment>>>
    export type UpdateAdminMessagingAssignmentMutationBody = MessagingAdminAssignmentRequest
    export type UpdateAdminMessagingAssignmentMutationError = Problem

    /**
 * @summary Reassign a conversation to another PEXIFY user
 */
export const useUpdateAdminMessagingAssignment = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminMessagingAssignment>>, TError,{conversationId: string;data: MessagingAdminAssignmentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminMessagingAssignment>>,
        TError,
        {conversationId: string;data: MessagingAdminAssignmentRequest},
        TContext
      > => {
      return useMutation(getUpdateAdminMessagingAssignmentMutationOptions(options), queryClient);
    }
    export type updateAdminMessagingOperationsResponse200 = {
  data: MessagingAdminConversation
  status: 200
}

export type updateAdminMessagingOperationsResponse403 = {
  data: Problem
  status: 403
}

export type updateAdminMessagingOperationsResponse404 = {
  data: Problem
  status: 404
}

export type updateAdminMessagingOperationsResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type updateAdminMessagingOperationsResponseSuccess = (updateAdminMessagingOperationsResponse200) & {
  headers: Headers;
};
export type updateAdminMessagingOperationsResponseError = (updateAdminMessagingOperationsResponse403 | updateAdminMessagingOperationsResponse404 | updateAdminMessagingOperationsResponseDefault) & {
  headers: Headers;
};

export type updateAdminMessagingOperationsResponse = (updateAdminMessagingOperationsResponseSuccess | updateAdminMessagingOperationsResponseError)

export const getUpdateAdminMessagingOperationsUrl = (conversationId: string,) => {




  return `/api/v1/admin/messaging/conversations/${conversationId}/operations`
}

/**
 * Requires current conversation containment and
 * messaging.conversation.view. A supplied status additionally requires
 * messaging.conversation.manage; a supplied waiting_on additionally
 * requires messaging.waiting.correct; supplying both requires both. Every
 * successful update is audited. A1/A2 classification and Ring-3 scope never
 * imply any capability. The server rejects a request with neither field.
 *
 * @summary Update conversation status or response responsibility
 */
export const updateAdminMessagingOperations = async (conversationId: string,
    messagingAdminOperationsRequest: MessagingAdminOperationsRequest, options?: RequestInit): Promise<updateAdminMessagingOperationsResponse> => {

  return orvalClient<updateAdminMessagingOperationsResponse>(getUpdateAdminMessagingOperationsUrl(conversationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingAdminOperationsRequest)
  }
);}




export const getUpdateAdminMessagingOperationsMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminMessagingOperations>>, TError,{conversationId: string;data: MessagingAdminOperationsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminMessagingOperations>>, TError,{conversationId: string;data: MessagingAdminOperationsRequest}, TContext> => {

const mutationKey = ['updateAdminMessagingOperations'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminMessagingOperations>>, {conversationId: string;data: MessagingAdminOperationsRequest}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  updateAdminMessagingOperations(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminMessagingOperationsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminMessagingOperations>>>
    export type UpdateAdminMessagingOperationsMutationBody = MessagingAdminOperationsRequest
    export type UpdateAdminMessagingOperationsMutationError = Problem

    /**
 * @summary Update conversation status or response responsibility
 */
export const useUpdateAdminMessagingOperations = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminMessagingOperations>>, TError,{conversationId: string;data: MessagingAdminOperationsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminMessagingOperations>>,
        TError,
        {conversationId: string;data: MessagingAdminOperationsRequest},
        TContext
      > => {
      return useMutation(getUpdateAdminMessagingOperationsMutationOptions(options), queryClient);
    }
    export type markAdminMessagingConversationReadResponse200 = {
  data: MessagingReadReceipt
  status: 200
}

export type markAdminMessagingConversationReadResponse403 = {
  data: Problem
  status: 403
}

export type markAdminMessagingConversationReadResponse404 = {
  data: Problem
  status: 404
}

export type markAdminMessagingConversationReadResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type markAdminMessagingConversationReadResponseSuccess = (markAdminMessagingConversationReadResponse200) & {
  headers: Headers;
};
export type markAdminMessagingConversationReadResponseError = (markAdminMessagingConversationReadResponse403 | markAdminMessagingConversationReadResponse404 | markAdminMessagingConversationReadResponseDefault) & {
  headers: Headers;
};

export type markAdminMessagingConversationReadResponse = (markAdminMessagingConversationReadResponseSuccess | markAdminMessagingConversationReadResponseError)

export const getMarkAdminMessagingConversationReadUrl = (conversationId: string,) => {




  return `/api/v1/admin/messaging/conversations/${conversationId}/read`
}

/**
 * Requires current conversation containment and the exact capability
 * messaging.conversation.view. It advances only the authenticated PEXIFY
 * user's server-derived read position and records an audit event. A1/A2
 * classification and Ring-3 scope never imply the capability.
 *
 * @summary Advance the current PEXIFY user's read position
 */
export const markAdminMessagingConversationRead = async (conversationId: string,
    messagingReadRequest: MessagingReadRequest, options?: RequestInit): Promise<markAdminMessagingConversationReadResponse> => {

  return orvalClient<markAdminMessagingConversationReadResponse>(getMarkAdminMessagingConversationReadUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingReadRequest)
  }
);}




export const getMarkAdminMessagingConversationReadMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAdminMessagingConversationRead>>, TError,{conversationId: string;data: MessagingReadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markAdminMessagingConversationRead>>, TError,{conversationId: string;data: MessagingReadRequest}, TContext> => {

const mutationKey = ['markAdminMessagingConversationRead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAdminMessagingConversationRead>>, {conversationId: string;data: MessagingReadRequest}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  markAdminMessagingConversationRead(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAdminMessagingConversationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAdminMessagingConversationRead>>>
    export type MarkAdminMessagingConversationReadMutationBody = MessagingReadRequest
    export type MarkAdminMessagingConversationReadMutationError = Problem

    /**
 * @summary Advance the current PEXIFY user's read position
 */
export const useMarkAdminMessagingConversationRead = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAdminMessagingConversationRead>>, TError,{conversationId: string;data: MessagingReadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAdminMessagingConversationRead>>,
        TError,
        {conversationId: string;data: MessagingReadRequest},
        TContext
      > => {
      return useMutation(getMarkAdminMessagingConversationReadMutationOptions(options), queryClient);
    }
    export type listAdminMessagingMessagesResponse200 = {
  data: MessagingMessagePage
  status: 200
}

export type listAdminMessagingMessagesResponse403 = {
  data: void
  status: 403
}

export type listAdminMessagingMessagesResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 200 | 403>
}

export type listAdminMessagingMessagesResponseSuccess = (listAdminMessagingMessagesResponse200) & {
  headers: Headers;
};
export type listAdminMessagingMessagesResponseError = (listAdminMessagingMessagesResponse403 | listAdminMessagingMessagesResponseDefault) & {
  headers: Headers;
};

export type listAdminMessagingMessagesResponse = (listAdminMessagingMessagesResponseSuccess | listAdminMessagingMessagesResponseError)

export const getListAdminMessagingMessagesUrl = (conversationId: string,
    params?: ListAdminMessagingMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/messaging/conversations/${conversationId}/messages?${stringifiedParams}` : `/api/v1/admin/messaging/conversations/${conversationId}/messages`
}

/**
 * Returns cursor-paginated message history only after the same declared
 * support or governance scope, explicit messaging.conversation.view
 * capability, containment, and audit checks as the admin conversation.
 * Ring-3 alone is insufficient. This read route grants no mutation,
 * private team chat, or break-glass authority.
 *
 * @summary List message history through governed admin access
 */
export const listAdminMessagingMessages = async (conversationId: string,
    params?: ListAdminMessagingMessagesParams, options?: RequestInit): Promise<listAdminMessagingMessagesResponse> => {

  return orvalClient<listAdminMessagingMessagesResponse>(getListAdminMessagingMessagesUrl(conversationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminMessagingMessagesQueryKey = (conversationId: string,
    params?: ListAdminMessagingMessagesParams,) => {
    return [
    `/api/v1/admin/messaging/conversations/${conversationId}/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminMessagingMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError = void | Problem>(conversationId: string,
    params?: ListAdminMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminMessagingMessagesQueryKey(conversationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminMessagingMessages>>> = ({ signal }) => listAdminMessagingMessages(conversationId,params, { signal });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminMessagingMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminMessagingMessages>>>
export type ListAdminMessagingMessagesQueryError = void | Problem


export function useListAdminMessagingMessages<TData = Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError = void | Problem>(
 conversationId: string,
    params: undefined |  ListAdminMessagingMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminMessagingMessages>>,
          TError,
          Awaited<ReturnType<typeof listAdminMessagingMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminMessagingMessages<TData = Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError = void | Problem>(
 conversationId: string,
    params?: ListAdminMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminMessagingMessages>>,
          TError,
          Awaited<ReturnType<typeof listAdminMessagingMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminMessagingMessages<TData = Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError = void | Problem>(
 conversationId: string,
    params?: ListAdminMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List message history through governed admin access
 */

export function useListAdminMessagingMessages<TData = Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError = void | Problem>(
 conversationId: string,
    params?: ListAdminMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminMessagingMessagesQueryOptions(conversationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type createAdminMessagingMessageResponse201 = {
  data: MessagingMessage
  status: 201
}

export type createAdminMessagingMessageResponse403 = {
  data: Problem
  status: 403
}

export type createAdminMessagingMessageResponse404 = {
  data: Problem
  status: 404
}

export type createAdminMessagingMessageResponseDefault = {
  data: Problem
  status: Exclude<HTTPStatusCodes, 201 | 403 | 404>
}

export type createAdminMessagingMessageResponseSuccess = (createAdminMessagingMessageResponse201) & {
  headers: Headers;
};
export type createAdminMessagingMessageResponseError = (createAdminMessagingMessageResponse403 | createAdminMessagingMessageResponse404 | createAdminMessagingMessageResponseDefault) & {
  headers: Headers;
};

export type createAdminMessagingMessageResponse = (createAdminMessagingMessageResponseSuccess | createAdminMessagingMessageResponseError)

export const getCreateAdminMessagingMessageUrl = (conversationId: string,) => {




  return `/api/v1/admin/messaging/conversations/${conversationId}/messages`
}

/**
 * Requires current conversation containment plus the exact capabilities
 * messaging.conversation.view and messaging.conversation.reply. A request
 * with kind=internal_note additionally requires
 * messaging.internal_note.create. Every successful send is audited. A1/A2
 * classification and Ring-3 scope never imply any capability. This reuses
 * the existing message contract and makes no provider or realtime claim.
 *
 * @summary Send an admin reply or internal note
 */
export const createAdminMessagingMessage = async (conversationId: string,
    messagingMessageCreate: MessagingMessageCreate, options?: RequestInit): Promise<createAdminMessagingMessageResponse> => {

  return orvalClient<createAdminMessagingMessageResponse>(getCreateAdminMessagingMessageUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingMessageCreate)
  }
);}




export const getCreateAdminMessagingMessageMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminMessagingMessage>>, TError,{conversationId: string;data: MessagingMessageCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminMessagingMessage>>, TError,{conversationId: string;data: MessagingMessageCreate}, TContext> => {

const mutationKey = ['createAdminMessagingMessage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminMessagingMessage>>, {conversationId: string;data: MessagingMessageCreate}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  createAdminMessagingMessage(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminMessagingMessageMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminMessagingMessage>>>
    export type CreateAdminMessagingMessageMutationBody = MessagingMessageCreate
    export type CreateAdminMessagingMessageMutationError = Problem

    /**
 * @summary Send an admin reply or internal note
 */
export const useCreateAdminMessagingMessage = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminMessagingMessage>>, TError,{conversationId: string;data: MessagingMessageCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdminMessagingMessage>>,
        TError,
        {conversationId: string;data: MessagingMessageCreate},
        TContext
      > => {
      return useMutation(getCreateAdminMessagingMessageMutationOptions(options), queryClient);
    }
